import { PCShareSocialNetwork } from '../models';
export function getHeaderTag(size) {
    switch (size) {
        case 'l':
            return 'h1';
        case 's':
            return 'h4';
        case 'xs':
            return 'h5';
        case 'm':
        default:
            return 'h2';
    }
}
export function getBlockKey(block, index) {
    return `${block.type}-${index}`;
}
export const getCustomBlockTypes = ({ blocks = {}, headers = {} } = {}) => [
    ...Object.keys(blocks),
    ...Object.keys(headers),
];
export const getCustomItems = ({ blocks = {}, headers = {}, subBlocks = {} } = {}) => (Object.assign(Object.assign(Object.assign({}, blocks), headers), subBlocks));
export const getCustomSubBlockTypes = (customBlocks = {}) => {
    const { subBlocks = {} } = customBlocks;
    return Object.keys(subBlocks);
};
export const getCustomHeaderTypes = (customBlocks = {}) => {
    const { headers = {} } = customBlocks;
    return Object.keys(headers);
};
const getShareUrlWithParams = (url, params = {}) => {
    const result = new URL(url);
    Object.entries(params).forEach(([name, value]) => {
        if (value) {
            result.searchParams.set(name, value);
        }
    });
    return result.toString();
};
export const getOrderedBlocks = (blocks, headerBlockTypes = []) => {
    return blocks.filter(({ type }) => !headerBlockTypes.includes(type));
};
export const getHeaderBlock = (blocks, headerBlockTypes = []) => {
    return blocks.find(({ type }) => headerBlockTypes.includes(type));
};
export const getShareLink = (url, type, title, text) => {
    // https://github.com/bradvin/social-share-urls
    switch (type) {
        case PCShareSocialNetwork.Telegram:
            return getShareUrlWithParams('https://t.me/share/url', { url, text: title });
        case PCShareSocialNetwork.Facebook:
            return getShareUrlWithParams('https://facebook.com/sharer.php', { u: url });
        case PCShareSocialNetwork.Twitter:
            return getShareUrlWithParams('https://twitter.com/intent/tweet', {
                url,
                text: title,
            });
        case PCShareSocialNetwork.Vk:
            return getShareUrlWithParams('https://vk.com/share.php', {
                url,
                title,
                comment: text,
            });
        case PCShareSocialNetwork.LinkedIn:
            return getShareUrlWithParams('https://www.linkedin.com/sharing/share-offsite/', {
                url,
            });
        default:
            // eslint-disable-next-line no-console
            console.error(`Unknown share type: ${type}`);
            return undefined;
    }
};
export const getBlockIndexFromId = (blockId) => { var _a; return Number((_a = blockId === null || blockId === void 0 ? void 0 : blockId.split('-')) === null || _a === void 0 ? void 0 : _a.slice(-1).pop()); };
